// extracted by mini-css-extract-plugin
module.exports = {"quantityField":"style_quantityField__42H7M","inputButton":"style_inputButton__cZ8t_"};